import { FormattedMessage } from 'react-intl';

import DefaultMaturityDate from '@/App/UserPreferences/CashTab/DefaultMaturityDate.tsx';
import DefaultNotional from '@/App/UserPreferences/CashTab/DefaultNotional.tsx';

export const CashTab = () => {
  return (
    <div className="overflow-y-auto">
      {/* Should be removed in forex */}
      {/* <p className="mt-1 mb-2">
        <FormattedMessage id="userPreferences.section.displayPreferences" />
      </p>

      <div className="border">
        <ShowSwapPoints />
        <ShowOrderQuickLimit />
      </div> */}

      <p className="mb-2">
        <FormattedMessage id="userPreferences.section.default" />
      </p>

      <div className="border">
        <DefaultNotional />
        <DefaultMaturityDate />
      </div>
    </div>
  );
};
